module.exports = __webpack_public_path__ + "static/media/App icon Retro.513e473f.png";